import Service from "../Service";
const resource = "Packing/";

export default {
  pagination(obj, requestID) {
    return Service.post(resource + "paginationSummaryTemplate", obj, {
      params: { requestID },
    });
  },
};
